export default __webpack_public_path__ + "static/media/asktheexpertdashboard.6846c487.svg";